import React from "react";

const Label = ({ className = "", required = false, children, style, htmlFor }) => {
  const labelClassName = `builder_label ${className}`.trim();
  const asteriskClassName = required ? "label_required_asterisk" : "";

  return (
    <label className={labelClassName} style={style} htmlFor={htmlFor}>
      {children}
      {required && <span className={asteriskClassName}>*</span>}
    </label>
  );
};

export default Label;
